import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import partyIcon from "../../Assets/Icons/party.png";
import LoaderBox from "../HomePage/LoaderBox";
import Navigation from "../Navigation/Navigation";
import HomeFooter from "../HomePage/HomeFooter";
import BottomNavigation from "../Navigation/BottomNavigation";

const FucaParty = () => {
  const { turnirSlug } = useParams();
  const [loading, setLoading] = useState(true);
  const [schedule, setSchedule] = useState([]);

  // Stanje za informacije o turniru (za Navigation)
  const [turnirInfo, setTurnirInfo] = useState({
    naziv: "",
    logo_url: "",
    lokacija: "",
    naziv_lokacije: "",
    features: {},
  });

  const fetchPartyData = useCallback(async () => {
    try {
      setLoading(true);

      if (!turnirSlug) {
        setLoading(false);
        return;
      }

      // Dohvaćamo turnir i njegove postavke prema slug-u iz tablice admin_turniri
      const { data: turnirData, error: turnirError } = await supabase
        .from("admin_turniri")
        .select(
          "naziv, logo_url, lokacija, naziv_lokacije, party_settings, features",
        )
        .eq("slug", turnirSlug)
        .single();

      if (turnirError) throw turnirError;

      if (turnirData) {
        setTurnirInfo({
          naziv: turnirData.naziv || "",
          logo_url: turnirData.logo_url || "",
          lokacija: turnirData.lokacija || "",
          naziv_lokacije: turnirData.naziv_lokacije || "",
          features: turnirData.features || {},
        });

        const partyData = turnirData.party_settings;

        let eventsArray = [];
        if (Array.isArray(partyData)) {
          eventsArray = partyData;
        } else if (partyData && Array.isArray(partyData.party_schedule)) {
          eventsArray = partyData.party_schedule;
        }

        const sortedData = eventsArray.sort((a, b) => {
          return String(a.date).localeCompare(String(b.date));
        });

        setSchedule(sortedData);
      }
    } catch (err) {
      console.error("Greška pri dohvaćanju party podataka:", err);
    } finally {
      setLoading(false);
    }
  }, [turnirSlug]);

  useEffect(() => {
    fetchPartyData();
  }, [fetchPartyData]);

  // Provjera je li događaj završio
  const isEventPast = (eventDate) => {
    if (!eventDate) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const evDate = new Date(eventDate);
    evDate.setHours(0, 0, 0, 0);
    return evDate < today;
  };

  // Formatiranje datuma: Dan, DD.MM.
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);

    const weekday = date.toLocaleDateString("hr-HR", { weekday: "long" });
    const capitalizedWeekday =
      weekday.charAt(0).toUpperCase() + weekday.slice(1);

    const day = date.getDate();
    const month = date.getMonth() + 1;

    return `${capitalizedWeekday}, ${day}.${month}.`;
  };

  if (loading) return <LoaderBox text="Učitavanje..." />;

  const hasEvents = schedule.length > 0;

  return (
    <>
      <Navigation
        turnirSlug={turnirSlug}
        turnirNaziv={turnirInfo.naziv}
        turnirLogo={turnirInfo.logo_url}
        lokacija={turnirInfo.lokacija}
        nazivLokacije={turnirInfo.naziv_lokacije}
        features={turnirInfo.features}
      />
      <div className="fuca-party-wrapper">
        <div className="party-header">
          <img src={partyIcon} alt="Party" className="header-img" />
          <h3>Ostali događaji</h3>
        </div>

        {hasEvents ? (
          <div className="party-list">
            {schedule.map((item) => {
              const past = isEventPast(item.date);
              return (
                <div
                  key={item.id || item.date}
                  className={`party-card-full ${past ? "event-past" : ""}`}
                >
                  {/* Ikona kvačice u kutu za završene događaje */}
                  {past && (
                    <div className="past-corner-badge">
                      <i className="fi fi-rs-circle-check"></i>
                    </div>
                  )}

                  {/* Središnji tekst preko bluranog sadržaja */}
                  {past && (
                    <div className="past-center-text">Događaj završio</div>
                  )}

                  {/* Unutarnji kontejner koji se zamućuje ako je događaj prošao */}
                  <div className="event-card-user-inner">
                    <h2>{formatDate(item.date)}</h2>

                    <div className="performers-container">
                      {/* Naslov / Naziv događaja */}
                      <span className="event-main-title">{item.title}</span>

                      {/* Prikaz vremena stiliziran kao nekadašnji timeline */}
                      {item.showTime && item.startTime && (
                        <div className="event-user-time-row">
                          <span className="time-badge">
                            {item.startTime} - {item.endTime} h
                          </span>
                        </div>
                      )}

                      {/* Opis događaja */}
                      {item.description && (
                        <p className="event-user-desc">{item.description}</p>
                      )}
                    </div>
                  </div>

                  <div className="shimmer-line"></div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="empty-party-container">
            <div className="party-card-empty">
              <h2>Trenutno nema zakazanih događaja</h2>
              <p>
                Pratite naše obavijesti! Uskoro objavljujemo detalje o zabavnom
                programu, hrani i piću nakon turnira.
              </p>
              <div className="shimmer-line"></div>
            </div>
          </div>
        )}
      </div>
      <BottomNavigation />
      <HomeFooter />
    </>
  );
};

export default FucaParty;
